/**
 * Peds-aware age display.
 * Uses date_of_birth when available for precise computation (days/months/years).
 * Falls back to the stored age integer when DOB is absent.
 */
export function displayAge(age?: number | null, dob?: string | null): string {
  if (dob) {
    const birth = new Date(dob);
    if (!isNaN(birth.getTime())) {
      const today = new Date();
      const totalDays = Math.floor((today.getTime() - birth.getTime()) / 86400000);
      if (totalDays < 0) return '';
      if (totalDays < 30) return `${totalDays}d`;
      const months =
        (today.getFullYear() - birth.getFullYear()) * 12 +
        (today.getMonth() - birth.getMonth()) -
        (today.getDate() < birth.getDate() ? 1 : 0);
      if (months < 24) return `${months}m`;
      return `${Math.floor(months / 12)}y`;
    }
  }
  if (age === undefined || age === null) return '';
  if (age === 0) return '< 1y';
  return `${age}y`;
}
